import { ThemePalette } from "@commonlibs";
import { basePalette } from "./basePalette";
import { OVERLAY_292730, OVERLAY_4F4F4F, OVERLAY_8C8C8C, OVERLAY_A7A7A7, OVERLAY_F7F7F7, OVERLAY_FFFFFF } from "./overlays";

export const gray: ThemePalette["gray"] = {
    "0": "#FFFFFF",
    "50": "#F7F7F7",
    "350": "#A7A7A7",
    "450": "#8C8C8C",
    "650": "#4F4F4F",
    "800": "#292730",
};

const overlays: ThemePalette["overlays"] = {
    "0": OVERLAY_FFFFFF,
    "50": OVERLAY_F7F7F7,
    "350": OVERLAY_A7A7A7,
    "450": OVERLAY_8C8C8C,
    "650": OVERLAY_4F4F4F,
    "800": OVERLAY_292730,
};

const text = gray[800];
const borderColor = overlays[800][8];
const otpBorderColor = overlays[800][20];
export const borderSm = `1px solid ${borderColor}`;
export const otpBorder = `1px solid ${otpBorderColor}`
export const borderMd = `2px solid ${borderColor}`;
const light = gray[350];

export const lightPalette: Partial<ThemePalette> = {
    mode: "light",
    ...basePalette,
    overlays,
    gray,
    disabled: overlays[800]["8"],
    background: gray[0],
    backdrop: overlays[800]["40"],
    components: {
        card: { background: gray[0] },
        input: {
            placeholderColor: overlays[800]["20"],
            border: borderSm,
            color: text,
        },
        divider: {
            height: "1px",
            background: borderColor,
        },
    },
    text,
    lightText: light,
};
